module.exports = __webpack_public_path__ + "static/media/iphone-3-landing-mobile-en.b2ed0a1c.png";